export default "__VITE_ASSET__CutIc8Xc__"